import { FormattedMessage } from 'react-intl';
import React from 'react';
import { SHIPPED_VIEW_ID, VOIDED_VIEW_ID } from './view-id-constants';

export const Voided = {
  label: <FormattedMessage defaultMessage='Voided' description='ordersPage.nav.voided' id='+iSSzh' />,
  id: VOIDED_VIEW_ID,
  expandedDescription: <FormattedMessage defaultMessage='Shipped / Voided' description='ordersPage.nav.voidedExpanded' id='jX+aBf' />,
  parentId: SHIPPED_VIEW_ID,
};
